import request from "@/utils/request";
export const getContactInfo = () => {
    return request.get("/contact/info");
};
export const updateContactInfo = (data) => {
    return request.put("/contact/info", data);
};
